import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function About() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  return (
    <div>
      <section id="starter-section" class="starter-section section">
        <div class="container section-title" data-aos="fade-up">
          <h2>About SYM Ventures</h2>
          <p>
            SYM Ventures LLP is a venture capital company based out of Mumbai,
            Maharashtra – India.
          </p>
        </div>

        {/* <div class="container" data-aos="fade-up">
  <p>Use this page as a starter for your own custom pages.</p>
</div> */}

        {/* </section>
     <section id="about" className="about section"> */}
        <div className="container">
          <div className="row gy-4">
            <div
              className="col-lg-7 content text-justify"
              data-aos="fade-up"
              // data-aos-delay="100"
            >
              {/* <h3 className="who-we-are">About SYM Ventures</h3> */}
              <p style={{ textAlign: "justify" }}>
                <strong>SYM Ventures LLP</strong> is a venture capital company
                based out of Mumbai, Maharashtra – India. <br />
                SYM facilitates the buying and selling of shares in companies
                that are privately held but are preparing to go public through
                an Initial Public Offering (IPO). <br />
                These companies are in the final stages of private funding and
                are usually seeking to raise additional capital through early
                investors, employees, or stakeholders before their IPO.
              </p>
              <p style={{ textAlign: "justify" }}>
                SYM focuses on companies researched by their expert analyst
                often in technologies like AI, biotech, or renewable energy
                which shape the future of those industries.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>SYM Ventures LLP </strong> is a subsidiary company of
                SYM Holdings Ltd. SYM Holding, a private investment company,
                strategically allocates resources across diverse sectors with
                high-growth potential. These sectors include hospitality,
                healthcare, Cruise Management logistics, technology, jewelry,
                mining, manufacturing, events, and trading.
              </p>
            </div>

            <div
              className="col-lg-5 about-images"
              data-aos="fade-up"
              // data-aos-delay="200"
            >
              <div className="row gy-4">
                <div className="col-lg-6">
                  <img
                    src="../assets/img/about-company-1.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="col-lg-6">
                  <div className="row gy-4">
                    <div className="col-lg-12">
                      <img
                        src="../assets/img/about-company-2.jpg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-12">
                      <img
                        src="../assets/img/about-company-3.jpg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gy-3">
            <div
              className="col-lg-12 content text-justify"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h4 className="who-we-are">Subsidiary Companies</h4>
            </div>
            <div className="col-lg-3" data-aos="fade-up" data-aos-delay="200">
              <div className="card cardHeight">
                <div className="card-body">
                  <h5 className="card-title">India</h5>
                  <ul>
                    <li>SYM Ventures LLP</li>
                    <li>SYM Hospitality Pvt. Ltd.</li>
                    <li>SYM Space Pvt. Ltd.</li>
                    <li>SYM Commercial Pvt. Ltd.</li>
                    <li>SYM Healthcare Pvt. Ltd.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3" data-aos="fade-up" data-aos-delay="300">
              <div className="card cardHeight">
                <div className="card-body">
                  <h5 className="card-title">Singapore</h5>
                  <ul>
                    <li>SYM Investment PTE Ltd</li>
                    <li>Singapore Trading Enterprises Pte Ltd</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3" data-aos="fade-up" data-aos-delay="400">
              <div className="card cardHeight">
                <div className="card-body">
                  <h5 className="card-title">UAE</h5>
                  <ul>
                    <li>Stagelife Events LLC</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3" data-aos="fade-up" data-aos-delay="500">
              <div className="card cardHeight">
                <div className="card-body">
                  <h5 className="card-title">Africa</h5>
                  <ul>
                    <li>Indo Guinee Gold Sarl</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="600">
              <div className="card cardHeight">
                <img
                  src="../assets/img/V@1.5x.png"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h3 className="card-title">Our Vision</h3>
                  <p className="card-text">
                    To empower individuals and institutions by providing
                    transparent, innovative, and seamless share trading
                    solutions, fostering financial growth and inclusivity in
                    global markets.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="700">
              <div className="card cardHeight">
                <img
                  src="../assets/img/M@1.5x.png"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h3 className="card-title">Our Mission</h3>
                  <p className="card-text">
                    Our mission is to transform investment opportunities,
                    traditionally available to HNIs, institutions, and
                    privileged investors, by making them accessible to the
                    public.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="800">
              <div className="card cardHeight">
                <img
                  src="../assets/img/G@1.5x.png"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h3 className="card-title">Our Goal</h3>
                  <p className="card-text">
                    Our goal is to become a trusted partner in the pre-IPO
                    domain by offering cutting-edge technology, exceptional
                    customer service, and comprehensive market insights, helping
                    our clients achieve their financial objectives with
                    confidence and efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="pricing"
        className="pricing section"
        data-aos="fade-up"
        data-aos-delay="900"
      >
        {/* Section Title */}
        <div
          className="container section-title aos-init aos-animate"
          // data-aos="fade-up"
        >
          <h2>Meet Our Team</h2>
          {/* <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p> */}
        </div>
        {/* End Section Title */}

        <div className="container">
          <div className="row gy-4">
            <div
              className="col-lg-3 aos-init aos-animate"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="our-team">
                <div className="picture">
                  <img
                    className="img-fluid"
                    alt="shaji yohannan"
                    src="../assets/img/Shaji Yohannan@1.5x.png"
                  />
                </div>
                <div className="team-content">
                  <h3 className="name">Shaji Yohannan</h3>
                  <h4 className="title">Chairman</h4>
                  <p>
                    A senior and seasoned businessman with over 30 years’
                    experience in highly challenging markets like Asia,
                    Australia, Europe and Middle East. An excellent marketing
                    and sales negotiator. He is passionate in achieving target
                    goal and driving the team to success.
                  </p>
                </div>
              </div>
            </div>
            {/* End Pricing Item */}

            <div
              className="col-lg-3 aos-init aos-animate"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="our-team">
                <div className="picture">
                  <img
                    className="img-fluid"
                    alt="sahaj"
                    src="../assets/img/Sahaj Yohannan@1.5x.png"
                  />
                </div>
                <div className="team-content">
                  <h3 className="name">Sahaj Yohannan</h3>
                  <h4 className="title">Vice Chairman</h4>
                  <p>
                    A young, talented graduate with a keen interest in
                    international trade and finance. He has been instrumental in
                    bringing new ideas to the company that helped it improve its
                    processes and reduce costs. He has good communication
                    skills, knowledge of e-commerce, and technical skills, good
                    interpersonal skills to get to a sound decision for the
                    betterment of the organization.
                  </p>
                </div>
              </div>
            </div>
            {/* End Pricing Item */}

            <div
              className="col-lg-3 aos-init aos-animate"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="our-team">
                <div className="picture">
                  <img
                    className="img-fluid"
                    alt="bonna"
                    src="../assets/img/Bonna Nunez@1.5x.png"
                  />
                </div>
                <div className="team-content">
                  <h3 className="name">Bonna Nunez</h3>
                  <h4 className="title">Chief Financial Officer</h4>
                  <p>
                    A professional expertise with more than 25 years relevant of
                    experience in multi-national company set-up like Inchcape
                    Shipping Services and Microsoft. Outstanding in problem
                    solving, critical thinking and analytical skills. Adept in
                    negotiation and presentation skills. Efficient to provide
                    oversight and leadership in executing projects in a smooth
                    track. Innovative and passionate with good interpersonal
                    skills and excellent written and verbal communication.
                  </p>
                </div>
              </div>
            </div>
            {/* End Pricing Item */}
            <div
              className="col-lg-3 aos-init aos-animate"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="our-team">
                <div className="picture">
                  <img
                    className="img-fluid"
                    alt="saiyad"
                    src="../assets/img/Saiyed Salim@1.5x.png"
                  />
                </div>
                <div className="team-content">
                  <h3 className="name">Salim Saiyed</h3>
                  <h4 className="title">AVP - Revenue & Strategies</h4>
                  <p>
                    With over 35 years of corporate experience and extensive
                    international exposure across regions including Asia and
                    Africa, Seasoned sales and marketing professional. Career
                    includes successful tenures at leading companies such as
                    Xerox, Godrej & Boyce, and Canon, among others.
                  </p>
                </div>
              </div>
            </div>
            {/* End Pricing Item */}
          </div>
        </div>
      </section>
      {/* /Team Section */}
    </div>
  );
}

export default About;
